<template>
  <div class="problem">
    <div class="title">使用问题</div>
    <ul class="content">
      <li v-for="item in data" :key="item.id">
        <h5>{{ item.title }}</h5>
        <ul>
          <li v-for="(res, index) in item.children" :key="index">
            <p>{{ res.title }}</p>
            <span>{{ res.content }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [
        {
          id: 0,
          title: "一、如何发布作业与任务？",
          children: [
            {
              title: "1.创建任务",
              content:
                "用户需要手动输入任务标题，选择任务类型（题库作业、自定义作业、课后预习、课后复习），可选择从题库或错题集中选取题目（具体流程请看如何组卷），也可上传作业文件，最后选择发布班级，设置发布和截止时间后，任务创建完成。",
            },
            {
              title: "2.发布任务",
              content:
                "教师创建完任务后便可立即发布，发布后试题保存至历史组卷，教师可以再次编辑或者直接将试题发送到平板教师端，同时家长也能在我们的微信公众号中接收到任务发布消息，作业库中的作业教师可以复用。",
            },
            {
              title: "3.查看任务报告",
              content:
                "教师发布完任务之后可以查看任务内容和学生的任务完成情况，客观题系统自动批阅，主观题教师可手动批阅，批阅完成后便可生成任务报告，方便老师查看学生的作业完成情况、正确率、典型错题和典型学生等，帮助老师以学定教。",
            },
          ],
        },
        {
          id: 1,
          title: "二、如何智能组卷？",
          children: [
            {
              title:
                "1.教师按照科目、年级、版本、册次筛选出章节/知识点，选出需要出题的部分，进行试题类型及数量设置，筛选试题难度后生成试卷。",
              content: "",
            },
            {
              title:
                "2.教师选完题之后，查看已组试卷，可以查看试题详情/对单个试题进行替换/从试题篮中拖拽试题进行覆盖/调整试题在试卷中的位置/删除试题。编辑完试题后，选择试题结构、答题卡、密封线类型打印纸张格式等，保存试卷或将试卷另存为新的试卷名称。",
              content: "",
            },
          ],
        },
        {
          id: 2,
          title: "三、如何协同备课？",
          children: [
            {
              title: "1.发布协同备课",
              content:
                "对新增的或历史的备课进行共享，点击查看协同备课即可看到备课列表。",
            },
            {
              title: "2.编辑协同备课",
              content:
                '在我的备课中点击查看协同备课看到本校所有教师发布的协同备课，教师可根据实际情况选择进行编辑完善，每次的编辑历史都将被保存，教师可从历史版本中查看。"',
            },
          ],
        },
      ],
    };
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.problem {
  background-color: #fff;
  padding: 30px 50px;
  padding-bottom: 80px;
  .title {
    font-size: 16px;
    line-height: 30px;
  }
  .content {
    margin-top: 20px;
    h5 {
      margin-top: 40px;
    }
    p {
      font-size: 14px;
      margin-top: 15px;
    }
    span {
      display: inline-block;
      font-size: 14px;
      line-height: 18px;
      text-indent: 2em;
    }
  }
}
</style>